import * as API from './api'
import * as Types from './Types'

export function tryGetBookingSystems(token) {
  return dispatch => {
    dispatch({
      type: Types.GET_BOOKING_SYSTEM
    })

    API.getBookingSystems(token)
      .then(response => {
        dispatch({
          type: Types.GET_BOOKING_SYSTEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_BOOKING_SYSTEM_FAILED,
          payload: 500
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/BookingSystems.js